var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSeta3(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 290,
    height: 248,
    viewBox: "0 0 290 248",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M65.4719 124L-39.2252 246.426L-37.8614 248L29.5938 248L135.55 124L65.4719 124Z",
    fill: "#181a27"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M65.1013 124L135.284 124L136.018 123.055L30.6919 -0.000423124L-39.3859 -0.000419617L65.9406 123.055L65.1013 124Z",
    fill: "#181a27"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M219.247 124L114.55 246.426L115.914 248L183.369 248L289.43 124L219.247 124Z",
    fill: "#181a27"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M218.506 124L288.688 124L289.423 123.055L184.201 -0.00042313L114.018 -0.000419617L219.345 123.055L218.506 124Z",
    fill: "#181a27"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSeta3);
export default __webpack_public_path__ + "static/media/SETA3.58b3494ac0ef5f0d0d7e667f0c1463c1.svg";
export { ForwardRef as ReactComponent };